/** True when the request is served from the e-paper subdomain. */
export function isEpaperSubdomainHost(host?: string | null): boolean {
  if (!host) return false;
  const hostname = host.split(",")[0]?.trim().split(":")[0]?.toLowerCase() || "";
  return hostname === "epaper.prajasakti.com" || hostname.startsWith("epaper.");
}

/**
 * Public path for an e-paper route.
 * prajasakti.com keeps `/epaper/...`.
 * epaper.prajasakti.com drops that prefix because the host already identifies the product.
 */
export function epaperPublicPath(path: string, onEpaperHost: boolean): string {
  const normalized = path.startsWith("/") ? path : `/${path}`;
  if (!onEpaperHost) return normalized;
  if (normalized === "/epaper") return "/";
  if (normalized.startsWith("/epaper/")) return normalized.slice("/epaper".length) || "/";
  return normalized;
}
